export default [
    {
        header: 'Users Manangement',
        resource: 'User',
        action: 'read',
       
        
    },
    {
      title: 'Users',
      icon: 'UserPlusIcon',
      route: 'user-read',  
      tagVariant: 'light-warning',
      resource: 'User',
      action: 'read',
     
    },
    
    {
        title: 'Groups',
        icon: 'UsersIcon',
        route: 'group-read',  
        tagVariant: 'light-warning',
        resource: 'Group',
        action: 'read',
       
      },
  ]